import React from 'react';
import Alert from "react-bootstrap/Alert";
import Icon from "../../common/Icon";
import LicenseService from "../../services/license-service";
import {LicenseInfo} from "../../types/LicenseInfo";
import {DialogService} from "../../common/Dialog";
import Notification from "../../common/Notification";
import LicenseSummary from "./LicenseSummary";
import LicenseSelector from "./LicenseSelector";

import "./SetLicenseAction.scss";
import {WorkbenchStateContext} from "../context/WorkbenchContext";

/**
 * Action for selecting, validating and updating the license of Ontotext Platform.
 */
class SetLicenseAction extends React.Component {

  static contextType = WorkbenchStateContext;

  constructor(props: {}) {
    super(props);
    this.onSelectedFile = this.onSelectedFile.bind(this);
  }

  private onSelectedFile(licenseFile: File) {
    if (licenseFile) {
      LicenseService.validateLicense(licenseFile)
        .then((licenseInfo) => this.confirm(licenseFile, licenseInfo))
        .catch((error: any) => SetLicenseAction.onInvalidLicense(error));
    }
  }

  private static onInvalidLicense(invalidLicense: LicenseInfo) {
    DialogService.warning({
      message: <InvalidLicenseAlert messages={invalidLicense.messages}/>
    });
  }

  private confirm(licenseFile: File, licenseInfo: LicenseInfo) {
    DialogService.confirm({
      title: 'Confirm the license details are correct',
      message: <LicenseSummary license={licenseInfo}/>,
      onConfirm: () => this.updateLicense(licenseFile)
    });
  }

  private updateLicense(licenseFile: File) {
    LicenseService.updateLicense(licenseFile).then(() => {
      this.context.onUpdate();
      Notification.success({message: "License was updated successfully"});
    }).catch((invalidLicense: LicenseInfo) => {
      Notification.error({message: `License was not updated! ${invalidLicense.messages}`});
    });
  }

  render() {
    if (this.context.license.isValid) {
      return false;
    }
    return (
      <Alert variant="warning" className="SetLicenseAction box-shadow py-2 px-3">
        <Icon icon="exclamation-triangle" className="mr-1"/>
        No valid license
        <LicenseSelector onSelected={this.onSelectedFile} className="ml-2"/>
      </Alert>
    );
  }
}

function InvalidLicenseAlert(props: { messages: string }) {
  return props.messages ? <Alert variant="warning">{props.messages}</Alert> : <>Invalid license!</>;

}

export default SetLicenseAction;
